/**
 *  Users.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import { Grid, Tabs, Tab } from "react-bootstrap";

// redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearUsers } from '../../actions/users';

// components
import DeforestationReportList from "./DeforestationReportList.jsx";
import Loading from "../Loader/Loader.jsx";

// style
import "./style.css";

// global
var firebase = require("../../firebase");

class DeforestationReport extends Component {
  
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            reports: [],
            quantity: 0,
        };
    }

    componentWillMount() {
        document.title = 'Security Care | Desmatamentos';
        this.reloadData()
    }

    reloadData = _ => {
        const { users } = this.props;
        this.setState({ loading: true })
        firebase.database.ref('reports/deforestation').orderByChild("createdAt").once('value').then((snap) => {
            const values = snap.val()
            let reports = []
            let quantity = 0
            for (let key in values) {
                let report = values[key]
                if(report.status > 0) {
                    report["key"] = key
                    const user = users[report.user]
                    if(user) {
                        report["userName"] = user.name
                        report["userPhone"] = user.phone
                    }
                    reports.unshift(report)
                    quantity++
                }
            }
            this.setState({ reports, quantity, loading: false })
        });
    }

    render() {
        const { reports, quantity, loading } = this.state;

        return (
            <div className="content bg-content">
                <Grid fluid>
                    <Tabs defaultActiveKey="0" id="uncontrolled-tab-example">

                        <Tab eventKey="0" title={`DESMATAMENTOS (${quantity})`}>
                            { loading ?
                                <Loading /> 
                            :
                                <DeforestationReportList reports={reports} reload={this.reloadData} />
                            }
                        </Tab>
                    </Tabs>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    users: store.users.users
});
  
const mapDispatchToProps = dispatch =>
    bindActionCreators({ clearUsers }, dispatch);
  
export default connect (mapStateToProps, mapDispatchToProps)(DeforestationReport);





// WEBPACK FOOTER //
// ./src/views/DeforestationReport/DeforestationReport.jsx